import { apiService, ConsumerAccountResponse, FinaliseAccountRequest } from '../../..'
import {
  DeactivateAccountRequest,
  UpdateAccountRequest,
  UpdateAccountDetailsRequest,
  CloseAccountRequest,
  CloseAccountEligibleResponse,
  UnsuitabilityQuestionsRequest,
  CreditContractRequest,
  CreditContractDocumentResponse,
} from '../types'

const baseURL = '/portal/consumers/account'

export const accountService = apiService.service.injectEndpoints({
  endpoints: (build) => ({
    getAccount: build.query<ConsumerAccountResponse, void>({
      query: () => ({
        url: baseURL,
        method: 'GET',
      }),
      providesTags: ['ConsumerAccount'],
    }),
    updateAccount: build.mutation<void, UpdateAccountRequest>({
      query: (req) => ({
        url: baseURL,
        method: 'PUT',
        data: req.body,
      }),
      invalidatesTags: ['ConsumerAccount'],
    }),
    deactivateAccount: build.mutation<void, DeactivateAccountRequest>({
      query: (req) => ({
        url: `${baseURL}/deactivate`,
        method: 'PUT',
        data: req.body,
      }),
      invalidatesTags: ['ConsumerAccount'],
    }),
    updateAccountDetail: build.mutation<void, UpdateAccountDetailsRequest>({
      query: (req) => ({
        url: `${baseURL}/update-account-details`,
        method: 'PUT',
        data: req,
      }),
      invalidatesTags: ['ConsumerAccount'],
    }),
    reactivateAccount: build.mutation<void, void>({
      query: () => ({
        url: `${baseURL}/reactivate`,
        method: 'PUT',
      }),
    }),
    closeAccount: build.mutation<void, CloseAccountRequest>({
      query: (req) => ({
        url: `${baseURL}/close`,
        method: 'PUT',
        data: req,
      }),
      invalidatesTags: ['ConsumerAccount'],
    }),
    getAccountCloseEligible: build.query<CloseAccountEligibleResponse, void>({
      query: () => ({
        url: `${baseURL}/close/eligible`,
        method: 'GET',
      }),
      providesTags: ['ConsumerAccount'],
    }),
    finaliseAccountDetails: build.mutation<void, FinaliseAccountRequest>({
      query: (req) => ({
        url: `${baseURL}/account-details`,
        method: 'POST',
        data: req,
      }),
    }),
    unsuitabilityQuestions: build.mutation<void, UnsuitabilityQuestionsRequest>({
      query: (req) => ({
        url: `${baseURL}/unsuitability-questions`,
        method: 'POST',
        data: req,
      }),
      invalidatesTags: ['CreditLimit'],
    }),
    creditContract: build.mutation<void, void | CreditContractRequest>({
      query: (req) => ({
        url: `${baseURL}/credit-contract`,
        method: 'POST',
        data: req,
      }),
    }),
    getCreditContractDocument: build.query<CreditContractDocumentResponse, void>({
      query: () => {
        return {
          url: `${baseURL}/credit-contract/documents`,
          method: 'POST',
        }
      },
    }),
  }),
})
